import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as routes from '../../constants/routes';
import SignOutButton from '../SignOutButton';
import AuthUserContext from '../AuthUserContext';
import { Navigation as StyledNav } from '../../styles/components';
import logo from '../logo.svg';
import CategoryLinks from './CategoryLinks';
const Navigation = ({ authUser }) => (
  <StyledNav>
    {authUser ? (
      <NavigationAuthorised user={authUser} />
    ) : (
      <NavigationUnAuthorised />
    )}
  </StyledNav>
);

const RoutineLinks = () => (
  <li>
    <Link to="/routines"> Routines </Link>
    <ul>
      <li>
        <Link to="/routines/add">Add Routine</Link>
      </li>
      <li>
        <Link to="/routines/my">My routines</Link>
      </li>
      <li>
        <Link to={routes.RANDOM_EXAMPLE}>Random snippet</Link>
      </li>
    </ul>
  </li>
);

const NavigationAuthorised = ({ user }) => (
  <div>
    <div>
      <Link to={routes.HOME}>
        <img src={logo} />
      </Link>
    </div>
    <ul>
      <CategoryLinks />
      <li>
        <Link to={routes.SNIPPETS}> Snippets </Link>
        <ul>
          <li>
            <Link to={routes.ADD_SNIPPET}>Add snippet</Link>
          </li>
          <li>
            <Link to="/my-snippets">My snippets</Link>
          </li>

          <li>
            <Link to={routes.RANDOM_EXAMPLE}>Random snippet</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to={routes.ACCOUNT}>Account</Link>
        <ul>
          <li />
          <li>
            <Link to={routes.LANDING}>Landing</Link>
          </li>
          <li>
            <Link to="/account/change-password">Change Password</Link>
          </li>

          <li>
            <SignOutButton style={{ textAlign: 'right' }} />
          </li>
        </ul>
      </li>
    </ul>
  </div>
);

const NavigationUnAuthorised = () => (
  <div>
    <Link to={routes.LANDING}>
      <img src={logo} />
    </Link>
    <ul>
      <li>
        <Link to={routes.SIGN_IN}>Sign in</Link>
      </li>
    </ul>
  </div>
);
const mapStateToProps = ({ sessionState }) => ({
  authUser: sessionState.authUser
});
export default connect(mapStateToProps)(Navigation);
